module.exports = __webpack_public_path__ + "static/media/error_icon.976a5d2f.svg";